import { inject, Injectable } from '@angular/core';
import { WA_WINDOW } from '@ng-web-apis/common';
import { AnalyticsStrategy } from '../../analytics.model';
import { YANDEX_METRIKA_ID } from './yandex-metrika.tokens';

@Injectable({ providedIn: 'root' })
export class YandexMetrikaStrategy implements AnalyticsStrategy {
  readonly #id = inject(YANDEX_METRIKA_ID);
  readonly #window = inject(WA_WINDOW);

  trackEvent(event: string, params?: Record<string, unknown>) {
    this.#window.ym?.(this.#id, 'reachGoal', event, params);
  }

  trackPage(url: string) {
    this.#window.ym?.(this.#id, 'hit', url);
  }
}
